import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenMediaLinksItemProjectInfoEngagement } from './getExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenMediaLinksItemProjectInfoEngagement';

/**
 * 프로젝트 링크인 경우 추가 정보 (우리 사이트 내부 링크)
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenMediaLinksItemProjectInfo = {
  /** 프로젝트 참여 통계 */
  engagement?: GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenMediaLinksItemProjectInfoEngagement;
  /** 프로젝트 ID */
  projectId?: number;
};
